export enum CalendarViewColumns {
  DATE = 'Date',
  NAME = 'Name',
  NOTES = 'Notes',
}
